<template>
  <div class="home">
<!--    <TemporaryContestBanner v-if="isTournamentAvailable" />-->
    <BigTop />
    <div class="temporary-banner-margin">
      <HomeHotEvents></HomeHotEvents>
      <RecentItems
        title="Recent projects shared by our community"
        objectNamePlural="Projects"
        apiUrl="/projects/recent"
        nameFormat="nick"
        viewAllUrl="/projects"
      >
      </RecentItems>
      <HomeContest></HomeContest>
      <HomepageNews></HomepageNews>
      <RecentItems
        title="Learn something new with our experts"
        objectNamePlural="Educational Materials"
        apiUrl="/articles/learns?sortBy=order&sortDirection=asc&page=1&itemsPerPage=4"
        viewAllUrl="/learn"
      >
        <template v-slot:default="{ item }">
          <ArticleCardItem :item="item" itemUrlBase="/learn"></ArticleCardItem>
        </template>
      </RecentItems>
      <HomeMeetOurTeam></HomeMeetOurTeam>
    </div>
  </div>
</template>

<script>
import BigTop from '@/components/BigTop.vue'
// import TemporaryContestBanner from '@/components/TemporaryContestBanner.vue'
import RecentItems from '@/components/RecentItems.vue'
import HomepageNews from '@/components/HomepageNews.vue'
import HomeMeetOurTeam from '@/components/HomeMeetOurTeam.vue'
import HomeContest from '@/components/HomeContest.vue'
import HomeHotEvents from '@/components/HomeHotEvents.vue'
import ArticleCardItem from '@/components/article/CardItem.vue'

export default {
  name: 'Home',
  components: {
    BigTop,
    // TemporaryContestBanner,
    RecentItems,
    HomepageNews,
    HomeMeetOurTeam,
    HomeContest,
    HomeHotEvents,
    ArticleCardItem,
  },
  data: () => ({
    isTournamentAvailable: process.env.VUE_APP_IS_TOURNAMENT_AVAILABLE === 'true',
  }),
}
</script>

<style>
.avatar-move-top {
  position: absolute;
  bottom: -63px;
  width: 100%;
}

.add-border {
  border: 3px solid #fff;
}

.temporary-banner-margin {
  margin-top: 20px;
}
</style>
